import FacebookMessage from './FacebookMessage';
export default FacebookMessage;
